import * as bulkUpdate from './bulkUpdate.js';

export const schedules = [bulkUpdate];
